import useVehiclesMutations from "../../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import { IPart } from "../../../models/Part";
import classNames from "../../../utils/classNames";

export default function UnlistedKTypeUpdate({ part }: { part: IPart }) {
  const { update } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("KType");

  const handleKTypeUpdate = (kTypeString: string) => {
    if (!part.vehicle) return;

    let kType: number | null = Number.parseInt(kTypeString, 10);

    if (Number.isNaN(kType)) {
      kType = null;
    }

    if (part.vehicle.kType === kType) return;

    const updateVehicle = {
      ...part.vehicle,
      kType,
    };

    update.mutate(updateVehicle, {
      ...saveHandlers,
      onSuccess: () => {
        saveHandlers.onSuccess();
        if (part.vehicle) {
          part.vehicle.kType = kType;
        }
      },
    });
  };

  const inputClass = classNames(
    "w-full min-w-0 rounded border border-slate-200 bg-white px-1.5 py-0.5 text-xs text-black",
    "focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-400"
  );

  return (
    <label
      htmlFor={`kType-${part.id}`}
      className="flex items-center gap-1.5 text-xs text-black"
      onClick={(e) => e.stopPropagation()}
    >
      <span className="w-8 flex-none font-semibold uppercase tracking-wide text-black">
        KType
      </span>
      <input
        id={`kType-${part.id}`}
        key={part.id}
        defaultValue={part.vehicle?.kType ?? ""}
        className={inputClass}
        type="number"
        onBlur={(e) => handleKTypeUpdate(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            (e.target as HTMLInputElement).blur();
          }
        }}
      />
    </label>
  );
}